enum InspectionDBStatus {
  WAITING = 'WAITING',
  SENDING = 'SENDING',
  SENT = 'SENT',
  WITH_ERROR = 'WITH_ERROR'
}

export default InspectionDBStatus;
